<template>
    <div>
        <ul class="tab-navs spmg-bottom-db">
            <li class="tn-item current">
                下载记录
            </li>
        </ul>
        <ul class="favorites-list" v-show="isNum==1">
            <li class="post" v-for="(item,index) in loadList" :key="index"> 
                <div class="ctrl-areas">
                    <i class="iconfont iconxiazai" @click="dolow(item)"></i>
                </div>
                <div class="inners clearfix">
                    <router-link :to="{name:'Detailspage',query:{type:item.type,code:item.code}}" target="_blank" class="media-pics fl">
                        <img :src="item.pid==0?item.cover:item.image" alt="">
                    </router-link>
                    <div class="media-body">
                        <div class="hd">
                            <span class="post-date fr">{{item.time}}</span>
                            <span class="post-cates"><em class="cate-tag-icon" :class="item.type==1?'catePPt':'cateWord'">{{item.type==1?'BP演示版':'BP文档版'}}</em></span>
                        </div>
                        <div class="title">
                            <router-link :to="{name:'Detailspage',query:{type:item.type,code:item.code}}" target="_blank" >{{item.name}}</router-link>
                        </div>
                        <p class="post-meta">
                            <em>
                                <i class="iconfont iconai-eye"></i>{{item.pv}}
                            </em>
                            <em>
                                <i class="iconfont iconaixin"></i>{{item.laud}}
                            </em>
                        </p>
                    </div>
                </div>
            </li>
        </ul>
        <div class="d_list_empty" v-show="isNum==2">
                <i class="m-list-empty-img"></i>
                <span class="m-list-empty-txt">还没有下载模板</span>
                <router-link :to="{name:'indexPage'}">
                    <span class="m-list-empty-btn">
                        去首页看看
                    </span>
                </router-link>
            </div>
    </div>
</template> 
<script>
export default {
    data () {
        return {
            loadList:[],
            isNum:0
        }
    },
    methods: {
        download(){
            this.axios.mydownload({
                params:{
                    token:this.$store.state.token,
                }
            }).then(res=>{
                if(res.data.code==0){
                    var arr1 = res.data.data.ppt.rows
                    var arr2 = res.data.data.word.rows
                    var arr3=[...arr1, ...arr2]
                    this.loadList = arr3
                    if(this.loadList.length!=0){
                        this.isNum = 1
                    }else{
                        this.isNum = 2
                    }
                }else{
                    this.loadList = []
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        dolow(val){
            window.location.href = val.url
        }
    },
    mounted() {
        this.download()
    }
}
</script>
<style scoped>
@import "./../../styles/Page/Downloadlatest.css";
</style>